/** Builds a human-readable label for the current filter selection (for confirm dialogs). */

export function buildOfficeSelectionLabel(
  dataType: 'salary' | 'bonus',
  year: string,
  month: string,
  period: string,
  employeeCode: string
): string {
  const parts: string[] = [`${year}年`];
  if (dataType === 'salary') {
    parts.push(`${month}月`);
  } else {
    parts.push(`${period}期`);
  }
  if (employeeCode) {
    parts.push(`従業員コード ${employeeCode}`);
  }
  return parts.join('・');
}

export function buildConstructionSelectionLabel(
  year: string,
  month: string,
  genba: string,
  employeeName: string,
  dataType: 'salary' | 'bonus' = 'salary'
): string {
  const parts: string[] = [`${year}年`, dataType === 'bonus' ? `${month}期` : `${month}月`];
  if (genba) {
    parts.push(`現場 ${genba}`);
  }
  if (employeeName) {
    parts.push(`従業員 ${employeeName}`);
  }
  return parts.join('・');
}
